// default imports for react project
import React from "react";

// import default styles from react-bootstrap package
import { Col, Container, Row } from "react-bootstrap";

// Import images from assets folder
import { card_header_img } from "assets/images/images";

//   import custom component
import { BlackArrayText } from "components/Heading";
import BodyButton from "../Buttons/BodyButton";
import CardHeader from "./CardHeader";
import { H4Grey } from "components/Heading";
import { H3Red } from "components/Heading";
import { questionMark } from "assets/images/images";
import { H2Red } from "components/Heading";
import { VerticalSpacer } from "components";
import { plumberIcon } from "assets/images/images";
import { electricianIcon } from "assets/images/images";
import { retailIcon } from "assets/images/images";
import { productIcon } from "assets/images/images";
import { cleaningIcon } from "assets/images/images";
import { bedBreakfastIcon } from "assets/images/images";
import { restaurantIcon } from "assets/images/images";
import { onlineDistributionIcon } from "assets/images/images";
import { smallScaleProfesstionalIcon } from "assets/images/images";
import { hairdressessIcon } from "assets/images/images";
import { coachingClinicsIcon } from "assets/images/images";
import { yogaPilatesIcon } from "assets/images/images";
import { applianceIcon } from "assets/images/images";
import { constructionIcon } from "assets/images/images";
import { gardeningIcon } from "assets/images/images";
import { carIcon } from "assets/images/images";
import { deliveryIcon } from "assets/images/images";
import { othersIcon } from "assets/images/images";

// React functional component starts here..
function Card1({ width }) {

  return (
    <Col xs={12} className={`${width < 770 && 'p-0'}`}>
      <Row className={`m-0 pb-5 card__homepage ${width < 770 && 'p-0'}`}>
        <CardHeader image={card_header_img} disableButton={width > 770 ? false : true} title="What's Covered" />
        <Row className={width > 770 ? "mt-4" : 'm-0 pt-4'} >
          <H3Red className="card__list__header mt-5" >
            SureThing means there is no need for a range of policies or covers -
            you have one policy that deals with all third party legal liability.
          </H3Red>

          <div className={`mt-5 mb-3`}>
            <H3Red>SureThing includes:</H3Red>
          </div>
          <Row className={`${width < 770 ? 'p-0 m-0' : 'mt-3'}`}>
            <Col lg={4} xs={12}>
              <div className="red_container">
                <ul>
                  <li>Public liability</li>
                  <li>Product liability</li>
                  <li>Defective workmanship</li>
                  <li>Care, custody & control</li>
                  <li>Defamation</li>
                  <li>Pollution</li>
                  <li>Employment practices liability</li>
                  <li>Excess motor liability</li>
                  <li>Employers liability</li>
                  <li>Cyber liability</li>
                  <li>Directors & Officers liability</li>
                  <li>Professional indemnity liability</li>
                  <li>Trustee liability</li>
                </ul>
              </div>
            </Col>
            <Col>
              <h5 className={`${width < 500 ? 'mt-4 p-0' : ''} font-weight-bold`}>Uniquely effective protection</h5>

              Unique to <span className="text-danger">SureThing</span>, is that it includes POPIA regulatory enquiry legal costs, including legal assistance with notifications and legal costs for workplace vaccine disputes, and legal representation costs for the contravention of any law related to the conduct of the business. Simply put, regardless of the nature of the third-party claim alleging a legal liability, the policy covers legal costs to defend the claim and pays up to the limits for legal liability.
              <br />
              <br />

              Not only that, but because <span className="text-danger">SureThing</span> groups different types of cover under one end-to-end legal liability trigger, injury and damage (including pollution) third party claims are covered even if caused by a Cyber Incident, Directors and Officers liability or Professional Indemnity liability. Typically, these exclude bodily injury and property damage, often leading to gaps in cover.

            </Col>
          </Row>

          <div className="mt-5">
            <p className="grey_container__header">SureThing is ideal for small businesses such as: </p>
            <Row className="mt-4 grey_container">
              {icons.map((ele) =>
                <Col lg={2} xs={6} className="d-flex mt-3 text-center justify-content-start align-items-center flex-column">
                  <img src={ele.icon} alt='' />
                  <p className="mt-3 icon-text text-white">{ele.name}</p>
                </Col>
              )}
            </Row>
          </div>



          {width > 770 ? <Container>
            <Row className="mt-5">
              <Col lg={1}>
                <img src={questionMark} alt='questionMark' />
              </Col>
              <Col sm={11} className="text-left">
                <div className="ml-4">
                  <H2Red>WHAT’S COVERED?</H2Red> <br />
                  <VerticalSpacer rows={1} />
                  <H4Grey>SMEs with a turnover/revenue/fees of less than R20m pa and employing less than 20 employees, can apply. </H4Grey> <br />
                  <VerticalSpacer rows={1} />
                  <p>The SureThing policy by iTOO covers anything and everything for which SMEs are legally liable to a third party. No need for a range of covers: with SureThing, your clients have a single all-in-one policy that deals with all legal liability. There is a R2,5 million limit on claims with a cap of R5 million in the annual aggregate.</p>
                  <VerticalSpacer rows={1} />
                  <BlackArrayText link="/fast-facts">[ See Fast Facts ]</BlackArrayText>
                </div>
              </Col>
            </Row>
            <Row className="mt-4 w-100">
              <Col className={width < 500 ? 'text-center' : ''} xs={12} sm={12} lg={2}>
                <BodyButton
                  color="white"
                  bg="#da291c"
                  name="See Cover Details"
                  size={16}
                  marginL={0}
                  weight={700}
                  marginT={width > 770 ? 0 : 20}
                  black={width > 770 ? false : true}
                  link="/fast-facts"
                  id="landing-page-cover-details-button"
                />
              </Col>
              <Col >
                <div>
                  <span>Premium:</span>
                  <H3Red> R 1 000 pm</H3Red>
                </div>
              </Col>
            </Row>
          </Container> : <Container>
            <Row className="mt-5">
              <Col xs={2}>
                <img src={questionMark} className="questionMark" alt='questionMark' />
              </Col>
              <Col xs={10} className="text-left p-0 m-0">
                <div>
                  <H2Red>WHAT’S COVERED?</H2Red> <br />

                  <H4Grey>SMEs with a turnover/revenue/fees of less than R20m pa and employing less than 20 employees, can apply. </H4Grey> <br />
                  <VerticalSpacer rows={1} />

                </div>
              </Col>
            </Row>
            <p>The SureThing policy by iTOO covers anything and everything for which SMEs are legally liable to a third party. No need for a range of covers: with SureThing, your clients have a single all-in-one policy that deals with all legal liability. There is a R2,5 million limit on claims with a cap of R5 million in the annual aggregate.</p>
            <VerticalSpacer rows={1} />
            <div className="d-flex flex-column justify-content-center align-items-center w-100">
              <BlackArrayText link="/fast-facts">[ See Fast Facts ]</BlackArrayText>
              <div className="mt-5">
                <span>Premium:</span>
                <H3Red> R 1 000 pm</H3Red>
              </div>
              <BodyButton
                color="white"
                bg="#da291c"
                name="See Cover Details"
                size={16}
                marginL={0}
                weight={700}
                marginT={width > 770 ? 0 : 20}
                black={width > 770 ? false : true}
                link="/fast-facts"
                id="landing-page-cover-details-button"

              />

            </div>

          </Container>}
        </Row>


      </Row>
    </Col>
  );
}

export default Card1;


const icons = [
  {
    name: 'Plumbers',
    icon: plumberIcon
  },
  {
    name: 'Electricians',
    icon: electricianIcon
  },
  {
    name: 'Retail or shop owners',
    icon: retailIcon
  },
  {
    name: 'Product distributors and suppliers',
    icon: productIcon
  },
  {
    name: 'Cleaning companies',
    icon: cleaningIcon
  },
  {
    name: 'Bed and Breakfasts',
    icon: bedBreakfastIcon
  },
  {
    name: 'Restaurants, bakeries, and coffee shops',
    icon: restaurantIcon
  },
  {
    name: 'Online distributors',
    icon: onlineDistributionIcon
  },
  {
    name: 'Small-scale professional firms and service providers',
    icon: smallScaleProfesstionalIcon
  },
  {
    name: 'Hairdressers',
    icon: hairdressessIcon
  },
  {
    name: 'Coaching clinics and individual sport coaches',
    icon: coachingClinicsIcon
  },
  {
    name: 'Yoga and Pilates instructors and gyms',
    icon: yogaPilatesIcon
  },
  {
    name: 'Appliance repairers',
    icon: applianceIcon
  },
  {
    name: 'Construction companies',
    icon: constructionIcon
  },
  {
    name: 'Gardening services',
    icon: gardeningIcon
  },
  {
    name: 'Car washes',
    icon: carIcon
  },
  {
    name: 'Delivery services',
    icon: deliveryIcon
  },
  {
    name: 'and other similar industries',
    icon: othersIcon
  }
]